const WIDGET_SRC =
    'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'

/**
 * Loaded after hydration rather than from the document head.
 *
 * onInitialClientRender fires once React has finished hydrating, which is the
 * whole point: the bootstrap script rewrites the inside of every
 * `.trustpilot-widget` element, and those elements are rendered by React. Doing
 * that first makes React's markup and the DOM disagree, and React 18 responds
 * by throwing the server-rendered HTML away and re-rendering the page on the
 * client. See the note in gatsby-ssr.js.
 *
 * The widgets still appear on their own: the script scans the document when it
 * loads. TrustpilotWidgets.js also calls loadFromElement from an effect, which
 * covers a widget mounted by a later client-side navigation, when the script is
 * already present.
 *
 * Same shape as intercom-plugin, which loads its widget from the browser side
 * for the same reason.
 */
exports.onInitialClientRender = () => {
    if (document.querySelector(`script[src="${WIDGET_SRC}"]`)) return

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = WIDGET_SRC
    script.async = true
    document.head.appendChild(script)
}
